// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format19 } from '../../constants';

/** Bangladesh */
const BD: PhoneNumberData = [880, 'BD', 10, format19];

export default BD;
